<div class="select-container" [class.select-container-small]="size === 'small'">
  @for (type of showTypes; track type) {
    <div class="type-select" [class.select-container-disabled]="isDisabled(type.id)"
      (click)="onUnitTypeSelected(type.id)">
      @if (showTopArrow && !isDisabled(type.id)) {
        <div class="type-select-top-arrow">
          <div class="type-select-top-arrow-inner" lottie [options]="animationOptions"></div>
        </div>
      }
      <img class="type-select-image" src="{{type.image}}" animate.enter="app-show-hide-enter" animate.leave="app-show-hide-leave"/>
      <div class="name h4" translate>{{type.name}}</div>
      <div class="description h6" translate>{{type.description}}</div>
      <div></div>
    </div>
  }
</div>
